// ドライバーの在籍/退職判定（状態列を正とする）。
//
// 従来は `d.status === "退職" || !!d.contractTo` の OR 条件だったため、
// スプレッドシートの「状態」列だけを「退職」→「在職」に戻しても
// 「契約終了日」(contractTo) が残っていると退職扱いのままになる不具合があった。
// これを解消するため、状態列を優先し、状態が空のときだけ contractTo にフォールバックする。

import type { Driver } from "../types";

type StatusFields = Pick<Driver, "status" | "contractTo">;

// 在籍/退職の判定本体。
// - status === "退職" → 退職
// - status に値があり「退職」でない（例: "在職"） → 在籍（contractTo が残っていても在籍）
// - status が空/null → contractTo の有無でフォールバック（従来互換）
export function isRetiredDriver(d: StatusFields): boolean {
  if (d.status) {
    return d.status === "退職";
  }
  return !!d.contractTo;
}

// 在籍扱い（status が非退職）で contractTo が入っている状態は、実務上2通りある:
//   (a) これから契約終了する予定（未来日）  … 正常。ICB様の運用に実在する
//   (b) 退職処理を取り消したのに日付の消し忘れ（過去日）… 不整合
// 過去/未来を見ずに一律で警告すると、(a) の退職予定日まで「消してよい日付」に見えてしまう。
// そのため todayIso を渡した場合は (a) を警告から除外する。

/** 退職予定: 状態は在職のまま、契約終了日が今日以降に入っている（正常なデータ） */
export function isScheduledRetirement(d: StatusFields, todayIso: string): boolean {
  return !!d.status && d.status !== "退職" && !!d.contractTo && d.contractTo >= todayIso;
}

// 矛盾検知: 在籍扱い（statusが非退職の値）なのに contractTo が残っている行。
// todayIso を渡すと、未来日（＝退職予定）は矛盾に数えない。
// 省略時は従来どおり日付を見ずに判定する（呼び出し側の互換維持）。
export function hasStatusConflict(d: StatusFields, todayIso?: string): boolean {
  if (!d.status || d.status === "退職" || !d.contractTo) return false;
  if (todayIso && d.contractTo >= todayIso) return false;
  return true;
}
